import type { TOC } from '@ember/component/template-only';

import type { NewReportSlideLayout } from 'webapp/enums/enums';

import ReportsEditorSlideInner from 'webapp/components/reports/editor/slide-inner';
import ReportsEditorSlideType from 'webapp/components/reports/editor/slide-type';

import ReportSlideRecord from 'webapp/models/report-slide';

interface ReportsEditorEmptyComponentInterface {
	Args: {
		onAddNewSlide: (type: NewReportSlideLayout) => Promise<ReportSlideRecord>;
		addNewSlideLayoutsDisabled: NewReportSlideLayout[];
	};
}

const ReportsEditorEmptyComponent: TOC<ReportsEditorEmptyComponentInterface> = <template>
	<div class="report_slide_ct report_slide_ct--empty">
		<div class="report_slide_settings-and-inner">
			<ReportsEditorSlideInner>
				<div class="heading">
					<h2>Select a slide-type to start</h2>
					<p>Click below and select the slide-type you would like to start with</p>
				</div>
				<div class="types">
					<ReportsEditorSlideType
						@addNewSlideLayoutsDisabled={{@addNewSlideLayoutsDisabled}}
						@onSelect={{@onAddNewSlide}}
						@isButtonVisible={{true}}
					/>
				</div>
			</ReportsEditorSlideInner>
		</div>
	</div>
</template>;

export default ReportsEditorEmptyComponent;
